import { Dropdown, Input, Space } from "antd";
import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { GenericBankFeedsInfoIcon } from "../GenericBankFeedsInfoIcon";
import "./CreateGLAccountInput.css";

const DEFAULT_FONT_SIZE = 14;

export const CreateGLAccountInput = ({
  id,
  label,
  value,
  disabled,
  fontSize,
  infoText,
  setValue,
  placeholder,
  selectableItems,
}: {
  id: string;
  label: string;
  value?: string;
  disabled?: boolean;
  fontSize?: number;
  infoText?: string;
  setValue?: (value: string) => void;
  placeholder?: string;
  selectableItems?: JSX.Element;
}) => {
  const [infoHovering, setInfoHovering] = useState(false);

  const actualFontSize = fontSize ?? DEFAULT_FONT_SIZE;
  const getInputComponent = () => {
    if (selectableItems) {
      return (
        <Dropdown
          className="ml-1"
          disabled={disabled ?? false}
          overlay={selectableItems}
          trigger={["click"]}>
          <a
            onClick={(e) => e.preventDefault()}
            style={{
              width: 225,
              height: 30,
              outline: "1px solid #d3d3d3",
              outlineOffset: 2,
              borderRadius: 4,
              padding: "2px 8px",
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
            }}>
            <Space
              style={{
                width: 225,
                fontSize: actualFontSize,
                display: "flex",
                justifyContent: "space-between",
              }}>
              {value}
              <FiChevronDown />
            </Space>
          </a>
        </Dropdown>
      );
    }

    if (disabled || !setValue) {
      // If no mechanism is provided to change the value, the value has already been determined so disable the input.
      return (
        <Input
          style={{ width: 230, fontSize: actualFontSize }}
          value={value}
          disabled={true}
          placeholder={placeholder ?? value}
        />
      );
    }

    return (
      <Input
        style={{ width: 230, fontSize: actualFontSize }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
    );
  };
  return (
    <div
      className="mb-2"
      style={{
        width: 230,
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <label htmlFor={id} style={{ fontWeight: "bold" }}>
          {label}
        </label>
        {infoText && (
          <GenericBankFeedsInfoIcon
            text={infoText}
            hover={infoHovering}
            displayRight={true}
            onMouseEnter={() => {
              setInfoHovering(true);
            }}
            onMouseLeave={() => {
              setInfoHovering(false);
            }}></GenericBankFeedsInfoIcon>
        )}
      </div>
      {getInputComponent()}
    </div>
  );
};
